import { getLS } from "../utils/useLS";
import { insh, premiScr as pScr1, sto } from "./InshData";
import { insh as inshst } from "./InshSt";
import { elmnts, elmntall } from "./Elmnts";
import { col } from "./inshMt";
import { txtA, txtE } from "../Label/Lbl";
import dataF from "../Server/dataF.json";

import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import AssignmentReturnIcon from "@material-ui/icons/AssignmentReturn";
import MenuOpenIcon from "@material-ui/icons/MenuOpen";
import ReceiptIcon from "@material-ui/icons/Receipt";
import ReceiptTwoToneIcon from "@material-ui/icons/ReceiptTwoTone";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";
import SyncAltRoundedIcon from "@material-ui/icons/SyncAltRounded";
import ListAltIcon from "@material-ui/icons/ListAlt";

let pScr = getLS("premiScr", {});
// console.log('pScr')
// console.log(pScr)
// console.log('pScr')

const of = {
  sal: 0,
  parush: 1,
  safe: 2,
  customer: 3,
  account: 4,
  basic: 5,
  users: 6,
  setting: 7,
};

const elIcon = [
  { icon: AddShoppingCartIcon },
  { icon: ShoppingCartIcon },
  { icon: AssignmentReturnIcon },
  { icon: MenuOpenIcon },
  { icon: ReceiptIcon },
  { icon: ReceiptTwoToneIcon },
  { icon: ReceiptOutlinedIcon },
  { icon: SyncAltRoundedIcon },
  { icon: ListAltIcon },
];

const autos = {
  currType: [
    { id: 1, name: "مخزني" },
    { id: 2, name: "خام" },
    { id: 3, name: "صناعي" },
    { id: 4, name: "خدمي" },
    { id: 5, name: "لايباع" },
  ],
};

 const itmes = {
  idata: insh.items,
  front: {
    title: txtA.bascData.items,
    col: col.items,
    show: { rightDown: false },
  },
  setting: {
    tb: {
      wait: true,
      other: true,
      // groups: true,
      // Branches: true,
      // tax_groups: true,
      Units: true,
      // Currencies: true,
      parms: {
        fltrBranch: true,
        scurrenciestype: "C",
        tname: "curr",
        iempid: sto.empi,
        takei: 20,
        db_name:sto?.db_name
      },
      autos: { Branches: true, Units: true, tax_groups: true },
    },
    screen: "Items",
  },
  style: inshst.bascData.all,
};

const inshs = {
  Sales: {
    sal: {
      idata: insh.IdataInvs,
      stor: { invsType: 0 },
      setting: {
        titleHed: txtA.invName.sale,
        titleHedEn: txtE.invName.sale,
        cusType: 1,
        post: 0,
        cusN: txtA.cusNA,
        stors: itmes,
        priceNM: txtA.namePriceSal,
        priceTotNM: txtA.nameTotSal,
        PrTy_InPr: insh.IdataSa.ProcType_InvProc,
        iformid: dataF[47].id,
        routI_R_RS: "Inv_R_RS_ToS",
        routIS: "Inv_Sub_ToS/" /*routR:'',routRS:'',*/,
      },
      style: inshst.sal,
    },
    salRet: {
      idata: insh.IdataInvs,
      stor: { invsType: 1 },
      setting: {
        titleHed: txtA.invName.saleRet,
        titleHedEn: txtE.invName.saleRet,
        cusType: 1,
        post: 0,
        cusN: txtA.cusNA,
        stors: itmes,
        priceNM: txtA.namePriceSal,
        priceTotNM: txtA.nameTotSal,
        PrTy_InPr: insh.IdataSaR.ProcType_InvProc,
        iformid: dataF[49].id,
        routI_R_RS: "Inv_R_RS_ToS",
        routIS: "Inv_Sub_ToS/" /*routR:'',routRS:'',*/,
      },
      style: inshst.ret,
    },
    salViw: {
      idata: insh.IdataInvs,
      stor: { invsType: 2 },
      setting: {
        titleHed: txtA.invName.saleViw,
        titleHedEn: txtE.invName.saleViw,
        cusType: 1,
        post: 0,
        cusN: txtA.cusNA,
        stors: itmes,
        priceNM: txtA.namePriceSal,
        priceTotNM: txtA.nameTotSal,
        PrTy_InPr: insh.IdataSaV.ProcType_InvProc,
        iformid: dataF[59].id,
        routI_R_RS: "Inv_R_RS_ToS",
        routIS: "Inv_Sub_ToS/" /*routR:'',routRS:'',*/,
      },
      style: inshst.salView,
    },
    salAwleya: {
      idata: insh.IdataInvs,
      stor: { invsType: 2 },
      setting: {
        titleHed: txtA.invName.saleAwliya,
        titleHedEn: txtE.invName.saleAwliya,
        cusType: 1,
        post: 1,
        cusN: txtA.cusNA,
        stors: itmes,
        priceNM: txtA.namePriceSal,
        priceTotNM: txtA.nameTotSal,
        PrTy_InPr: insh.IdataSaV.ProcType_InvProc,
        iformid: dataF[59].id,
        routI_R_RS: "Inv_R_RS_ToS",
        routIS: "Inv_Sub_ToS/" /*routR:'',routRS:'',*/,
      },
      style: inshst.salView,
    },
    salWorkOrder: {
      idata: insh.IdataInvs,
      stor: { invsType: 2 },
      setting: {
        titleHed: txtA.invName.salWorkOrder,
        titleHedEn: txtE.invName.salWorkOrder,
        cusType: 1,
        post: 2,
        cusN: txtA.cusNA,
        stors: itmes,
        priceNM: txtA.namePriceSal,
        priceTotNM: txtA.nameTotSal,
        PrTy_InPr: insh.IdataSaV.ProcType_InvProc,
        iformid: dataF[59].id,
        routI_R_RS: "Inv_R_RS_ToS",
        routIS: "Inv_Sub_ToS/" /*routR:'',routRS:'',*/,
      },
      style: inshst.salView,
    },
    isharDept: {
      idata: insh.IdataInvs,
      stor: { invsType: 9 },
      setting: {
        titleHed: txtA.invName.saleIsharDept,
        titleHedEn: txtE.invName.saleIsharDept,
        cusType: 1,
        post: 0,
        cusN: txtA.cusNA,
        stors: itmes,
        priceNM: txtA.namePriceSal,
        priceTotNM: txtA.nameTotSal,
        PrTy_InPr:"150",
        iformid: 40002,
        routI_R_RS: "Inv_R_RS_ToS",
        routIS: "Inv_Sub_ToS/" /*routR:'',routRS:'',*/,
      },
      style: inshst.IsharView,
    },
    isharCredit: {
      idata: insh.IdataInvs,
      stor: { invsType: 10 },
      setting: {
        titleHed: txtA.invName.saleIsharCredit,
        titleHedEn: txtE.invName.saleIsharCredit,
        cusType: 1,
        post: 0,
        cusN: txtA.cusNA,
        stors: itmes,
        priceNM: txtA.namePriceSal,
        priceTotNM: txtA.nameTotSal,
        PrTy_InPr:"149",
        iformid: 40002,
        routI_R_RS: "Inv_R_RS_ToS",
        routIS: "Inv_Sub_ToS/" /*routR:'',routRS:'',*/,
      },
      style: inshst.IsharView,
    },
    saleVat: {
      titleHed: txtA.saleVat,
      systemId: 1,
    },
    purchVat: {
      titleHed: txtA.purchVat,
      systemId: 0,
    },
  },
  Purches: {
    purch: {
      idata: insh.IdataInvs,
      stor: { invsType: 3 },
      setting: {
        titleHed: txtA.invName.purch,
        titleHedEn: txtE.invName.purch,
        cusType: 2,
        post: 0,
        cusN: txtA.cusNM,
        stors: itmes,
        priceNM: txtA.namePricePurch,
        priceTotNM: txtA.nameTotPurch,
        PrTy_InPr: insh.IdataPa.ProcType_InvProc,
        iformid: dataF[46].id,
        routI_R_RS: "Inv_R_RS_ToP",
        routIS: "Inv_Sub_ToP/" /*routR:'',routRS:'',*/,
      },
      style: inshst.purch,
    },
    purchRet: {
      idata: insh.IdataInvs,
      stor: { invsType: 4 },
      setting: {
        titleHed: txtA.invName.purchRet,
        titleHedEn: txtE.invName.purchRet,
        cusType: 2,
        post: 0,
        cusN: txtA.cusNM,
        stors: itmes,
        priceNM: txtA.namePricePurch,
        priceTotNM: txtA.nameTotPurch,
        PrTy_InPr: insh.IdataPaR.ProcType_InvProc,
        iformid: dataF[48].id,
        routI_R_RS: "Inv_R_RS_ToP",
        routIS: "Inv_Sub_ToP/" /*routR:'',routRS:'',*/,
      },
      style: inshst.ret,
    },
    purchOrder: {
      idata: insh.IdataInvs,
      stor: { invsType: 6 },
      setting: {
        titleHed: txtA.invName.purchOrder,
        titleHedEn: txtE.invName.purchOrder,
        cusType: 2,
        post: 0,
        cusN: txtA.cusNM,
        stors: itmes,
        priceNM: txtA.namePricePurch,
        priceTotNM: txtA.nameTotPurch,
        PrTy_InPr: insh.IdataPuOr.ProcType_InvProc,
        iformid: dataF[114].id,
        routI_R_RS: "Inv_R_RS_ToP",
        routIS: "Inv_Sub_ToP/" /*routR:'',routRS:'',*/,
      },
      style: inshst.purch,
    },
  },
  Safes: {
    safe: {
      idata: insh.IdataInvs,
      stor: { invsType: 5 },
      setting: {
        titleHed: txtA.invName.safe,
        titleHedEn: txtE.invName.safe,
        cusType: 2,
        post: 0,
        cusN: txtA.cusNM,
        stors: "",
        priceNM: txtA.namePricePurch,
        priceTotNM: txtA.nameTotPurch,
        PrTy_InPr: insh.IdataSf.ProcType_InvProc,
        iformid: dataF[50].id,
        routI_R_RS: "Inv_R_RS_ToSf",
        routIS: "Inv_Sub_ToSf/" /*routR:'',routRS:'',*/,
      },
      style: inshst.safe,
    },
    manufacturing: {
      idata: insh.IdataInvs,
      stor: { invsType: 7 },
      setting: {
        titleHed: txtA.invName.manufacturing,
        titleHedEn: txtE.invName.manufacturing,
        cusType: 2,
        post: 0,
        cusN: txtA.cusNM,
        stors: "",
        priceNM: txtA.namePricePurch,
        priceTotNM: txtA.nameTotPurch,
        PrTy_InPr: insh.IdataMf.ProcType_InvProc,
        iformid: dataF[50].id,
        routI_R_RS: "Inv_R_RS_ToSf",
        routIS: "Inv_Sub_ToSf/" /*routR:'',routRS:'',*/,
      },
      style: inshst.safe,
    },
  },
  Customers: [
    { setting: { type: 1 } },
    { setting: { type: 2 } },

    { pcode: 123, front: "cust-account" },
    { pcode: 261, front: "sup-account" },
    { pcode: 123, front: "customers" },
    { pcode: 261, front: "suppliers" },

    // {
    //     idata:insh.Units,
    //     front:
    //     {
    //         elmnts:elmntall[3].card[5].grid[4],
    //         col:col.Units,
    //         title:txtA.customers.arsedah,
    //         show:{rightDown:false,}
    //     },
    //     setting:
    //     {
    //         tb:
    //         {
    //             wait:true, RptAccountBalance:true, Branches:true, costcenters:true, AccountsIndex:true,
    //             parms:insh.RptCustomer.arsedah,
    //             autos:{},
    //         },
    //         screen:'Arsedah',
    //     },
    //     style:inshst.bascData.all
    // }
  ],
  Accounts: {
    sQKharji: {
      sdata: insh.sandQK,
      stor: { invsType: 0 },
      setting: {
        titleHed: txtA.Accounts.sandQK,
        cusType: 1,
        cusN: txtA.cusSQK,
        accN: txtA.accSQK,
        priceNM: txtA.namePriceSal,
        priceTotNM: txtA.nameTotSal,
        PrTy_InPr: insh.IdataSa.ProcType_InvProc,
        iformid: dataF[47].id,
        routI_R_RS: "SandSQKh_R_RS_",
        routIS: "Inv_Sub_ToS/" /*routR:'',routRS:'',*/,
      },
      style: inshst.account,
    },
    sSKharji: {
      sdata: insh.sandDK,
      stor: { invsType: 1 },
      setting: {
        titleHed: txtA.Accounts.sandSK,
        cusType: 1,
        cusN: txtA.cusSSK,
        accN: txtA.accSSK,
        priceNM: txtA.namePriceSal,
        priceTotNM: txtA.nameTotSal,
        PrTy_InPr: insh.IdataSa.ProcType_InvProc,
        iformid: dataF[47].id,
        routI_R_RS: "SandSSKh_R_RS_",
        routIS: "Inv_Sub_ToS/" /*routR:'',routRS:'',*/,
      },
      style: inshst.account,
    },
    internalSQ: {
      sdata: insh.sandQD,
      stor: { invsType: 0 },
      setting: {
        titleHed: txtA.Accounts.sandQD,
        cusType: 1,
        cusN: txtA.cusSQD,
        accN: txtA.accSQK,
        priceNM: txtA.namePriceSal,
        priceTotNM: txtA.nameTotSal,
        PrTy_InPr: insh.IdataSa.ProcType_InvProc,
        iformid: dataF[47].id,
        routI_R_RS: "SandQD",
        routIS: "/" /*routR:'',routRS:'',*/,
      },
      style: inshst.account,
    },
    internalSS: {
      sdata: insh.sandSD,
      stor: { invsType: 1 },
      setting: {
        titleHed: txtA.Accounts.sandSD,
        cusType: 1,
        cusN: txtA.cusSSD,
        accN: txtA.accSSK,
        priceNM: txtA.namePriceSal,
        priceTotNM: txtA.nameTotSal,
        PrTy_InPr: insh.IdataSa.ProcType_InvProc,
        iformid: dataF[47].id,
        routI_R_RS: "SandSD",
        routIS: "/" /*routR:'',routRS:'',*/,
      },
      style: inshst.account,
    },
  },
  bascData: {
    Foundation: {
      idata: insh.Foundation,
      front: {
        elmnts: elmnts?.Units,
        col: col?.Units,
        title: txtA.bascData.unit,
        show: { rightDown: false },
      },
      setting: {
        tb: { wait: true, Units: true, parms: { tree: "sub",db_name:sto?.db_name }, autos: {} },
        screen: "Units",
      },
      style: inshst.bascData.all,
    },
    Branches: {
      idata: insh.Branches,
      front: {
        elmnts: elmnts.Branches,
        col: col.Branches,
        title: txtA.bascData.Branches,
        show: { rightDown: false },
      },
      setting: {
        tb: { wait: true, Branches: true, parms: { tree: "sub",db_name:sto?.db_name  }, autos: {} },
        screen: "Branches",
      },
      style: inshst.bascData.all,
    },
    Units: {
      idata: insh.Units,
      front: {
        elmnts: elmnts.Units,
        col: col.Units,
        title: txtA.bascData.unit,
        show: { rightDown: false },
      },
      setting: {
        tb: { wait: true, Units: true, parms: { tree: "sub",db_name:sto?.db_name }, autos: {} },
        screen: "Units",
      },
      style: inshst.bascData.all,
    },
    groups: {
      idata: insh.groups,
      front: {
        elmnts: elmnts.groups,
        col: col.groups,
        title: txtA.bascData.groups,
        show: { rightDown: false },
      },
      setting: {
        tb: { wait: true, groups: true, parms: { tree: "sub",db_name:sto?.db_name  }, autos: {} },
        screen: "groups",
      },
      style: inshst.bascData.all,
    },
    tax_groups: {
      idata: insh.tax_groups,
      front: {
        elmnts: elmnts.tax_groups,
        col: col.tax_groups,
        title: txtA.bascData.tax_groups,
        show: { rightDown: false },
      },
      setting: {
        tb: { wait: true, tax_groups: true, parms: { tree: "sub",db_name:sto?.db_name  }, autos: {} },
        screen: "tax_groups",
      },
      style: inshst.bascData.all,
    },
    Safes: {
      idata: insh.Safes,
      iemp: insh.Safe_Emps,
      front: {
        elmnts: elmnts.Safes,
        col: col.Safes,
        title: txtA.bascData.Safes,
        titleD: "المخزن",
        show: { rightDown: true },
      },
      setting: {
        tb: {
          wait: true,
          Safes: true,
          Employees: true,
          States: true,
          Branches: true,
          parms: { tree: "sub",db_name:sto?.db_name  },
          autos: { Employees: true, Branches: true },
        },
        screen: "Safes",
        moretb: "Safe_",
      },
      style: inshst.bascData.all,
    },
    Stocks: {
      idata: insh.Stocks,
      iemp: insh.Stock_Emps,
      front: {
        elmnts: elmnts.Stocks,
        col: col.Stocks,
        title: txtA.bascData.Stocks,
        titleD: "الصندوق",
        show: { rightDown: true },
      },
      setting: {
        tb: {
          wait: true,
          Stocks: true,
          Employees: true,
          States: true,
          Branches: true,
          parms: { tree: "sub",db_name:sto?.db_name  },
          autos: { Employees: true, Branches: true },
        },
        screen: "Stocks",
        moretb: "Stock_",
      },
      style: inshst.bascData.all,
    },
    Banks: {
      idata: insh.Banks,
      front: {
        elmnts: elmnts.Banks,
        col: col.Banks,
        title: txtA.bascData.Banks,
        show: { rightDown: false },
      },
      setting: {
        tb: {
          wait: true,
          More: true,
          Banks: true,
          AccountType: true,
          Countries: true,
          Cities: true,
          Areas: true,
          parms: { tname: "Acc", tree: "sub",db_name:sto?.db_name  },
          autos: { Countries: true, Cities: true, Areas: true },
        },
        screen: "Banks",
      },
      style: inshst.bascData.all,
    },
    costcenter: {
      idata: insh.costcenter,
      front: {
        elmnts: elmnts.costcenter,
        col: col.costcenter,
        title: txtA.bascData.costcenter,
        show: { rightDown: false },
      },
      setting: {
        tb: {
          wait: true,
          costcenters: true,
          parms: { tree: "sub",db_name:sto?.db_name  },
          autos: {},
        },
        screen: "costcenters",
      },
      style: inshst.bascData.all,
    },
    omlat: {
      idata: insh.omlat,
      front: {
        elmnts: elmnts.omlat,
        col: col.omlat,
        title: txtA.bascData.omlat,
        show: { rightDown: false },
      },
      setting: {
        tb: {
          wait: true,
          omlat: true,
          Countries: true,
          stateOmlat: true,
          equalOmlat: true,
          parms: { tree: "sub",db_name:sto?.db_name  },
          autos: { Countries: true },
        },
        screen: "omlat",
      },
      style: inshst.bascData.all,
    },
    AccountBooks: {
      idata: insh.AccountBooks,
      front: {
        elmnts: elmnts.AccountBooks,
        col: col.AccountBooks,
        title: txtA.bascData.AccountBooks,
        show: { rightDown: false },
      },
      setting: {
        tb: {
          wait: true,
          AccountBooks: true,
          parms: { tree: "sub",db_name:sto?.db_name  },
          autos: {},
        },
        screen: "AccountBooks",
      },
      style: inshst.bascData.all,
    },
    Acts: {
      idata: insh.Acts,
      front: {
        elmnts: elmnts.Acts,
        col: col.Acts,
        title: txtA.bascData.Acts,
        show: { rightDown: false },
      },
      setting: {
        tb: {
          wait: true,
          Acts: true,
          parms: { tree: "sub" ,db_name:sto?.db_name },
          autos: { Acts: true },
        },
        screen: "Acts",
      },
      style: inshst.bascData.all,
    },
    Countries: {
      idata: insh.Countries,
      front: {
        elmnts: elmnts.Countries,
        col: col.Countries,
        title: txtA.bascData.Countries,
        show: { rightDown: false },
      },
      setting: {
        tb: { wait: true, Countries: true, parms: { tree: "sub" ,db_name:sto?.db_name }, autos: {} },
        screen: "Countries",
      },
      style: inshst.bascData.all,
    },
    Cities: {
      idata: insh.Cities,
      front: {
        elmnts: elmnts.Cities,
        col: col.Cities,
        title: txtA.bascData.Cities,
        show: { rightDown: false },
      },
      setting: {
        tb: {
          wait: true,
          Cities: true,
          Countries: true,
          parms: { tree: "sub",db_name:sto?.db_name  },
          autos: { Countries: true },
        },
        screen: "Cities",
      },
      style: inshst.bascData.all,
    },
    Areas: {
      idata: insh.Areas,
      front: {
        elmnts: elmnts.Areas,
        col: col.Areas,
        title: txtA.bascData.Areas,
        show: { rightDown: false },
      },
      setting: {
        tb: {
          wait: true,
          Areas: true,
          Cities: true,
          parms: { tree: "sub",db_name:sto?.db_name  },
          autos: { Cities: true },
        },
        screen: "Areas",
      },
      style: inshst.bascData.all,
    },
    Managements: {
      idata: insh.Managements,
      front: {
        elmnts: elmnts.Managements,
        col: col.Managements,
        title: txtA.bascData.Managements,
        show: { rightDown: false },
      },
      setting: {
        tb: {
          wait: true,
          Managements: true,
          parms: { tree: "sub" ,db_name:sto?.db_name },
          autos: {},
        },
        screen: "Managements",
      },
      style: inshst.bascData.all,
    },
    Departments: {
      idata: insh.Departments,
      front: {
        elmnts: elmnts.Departments,
        col: col.Departments,
        title: txtA.bascData.Departments,
        show: { rightDown: false },
      },
      setting: {
        tb: {
          wait: true,
          Departments: true,
          Managements: true,
          parms: { tree: "sub",db_name:sto?.db_name  },
          autos: { Managements: true },
        },
        screen: "Departments",
      },
      style: inshst.bascData.all,
    },
    jobs: {
      idata: insh.jobs,
      front: {
        elmnts: elmnts.jobs,
        col: col.jobs,
        title: txtA.bascData.jobs,
        show: { rightDown: false },
      },
      setting: {
        tb: { wait: true, jobs: true, parms: { tree: "sub",db_name:sto?.db_name  }, autos: {} },
        screen: "jobs",
      },
      style: inshst.bascData.all,
    },
    CardTypes: {
      idata: insh.CardTypes,
      front: {
        elmnts: elmnts.CardTypes,
        col: col.CardTypes,
        title: txtA.bascData.CardTypes,
        show: { rightDown: false },
      },
      setting: {
        tb: { wait: true, CardTypes: true, parms: { tree: "sub",db_name:sto?.db_name  }, autos: {} },
        screen: "CardTypes",
      },
      style: inshst.bascData.all,
    },
  },
  Users: {},
  Settings: {},
};

const local = [
  {
    title: "sales-title",
    leftitle: "sale-system",
    of: of.sal,
    tabs: [
      { name: "page ", nmbr: 1, icon: "", disb: false },
      { name: "page ", nmbr: 2, icon: "", disb: false },
      { name: "page ", nmbr: 3, icon: "", disb: false },
      { name: 'page ', nmbr: 4, icon: '', disb: false },
      // {name:'إعدادات المبيعات ',nmbr:'', icon:'',disb:false},
    ],
    grid: [
      {
        tab: [
          {
            name: "sale-invoice",
            nmbr: "(1)",
            path: "Invoces",
            icon: "",
            disb: pScr.sal,
            insh: inshs.Sales.sal,
          },
          {
            name: "sale-billet",
            nmbr: "(2)",
            path: "Invoces",
            icon: "",
            disb: pScr.salRet,
            insh: inshs.Sales.salRet,
          },
          {
            name: "invoice-price",
            nmbr: "(3)",
            path: "Invoces",
            icon: "",
            disb: pScr.salView,
            insh: inshs.Sales.salViw,
          },
          {
            name: "closing-invoice",
            nmbr: "(4)",
            path: "ReportEqfalEveryDay",
            icon: "",
            disb: pScr.eqfDay,
          },
          // {name:'فاتورة تبديل', nmbr:'(4)',  path:'', icon:'',disb:false},        
          {
            name: "daily-rpt",
            nmbr: "(5)",
            path: "ReporteveryDay",
            icon: "",
            disb: pScr.evrDay,
          },
          {
            name: "close_shifts_report",
            nmbr: "(6)",
            path: "Shifts",
            icon: "",
            disb: pScr.activ,
          },
        ],
      },
      {
        tab: [
          // {name:'تقرير إقفال الوردية', nmbr:'(7)',  path:'', icon:'',disb:false},
          // {name:'تقرير النشاط التجاري', nmbr:'(8)',  path:'Activity', icon:'',disb:pScr.activ},
          {
            name: "active-rpt",
            nmbr: "(7)",
            path: "Activity",
            icon: "",
            disb: pScr.activ,
          },
          {
            name: "sale-tax-rpt",
            nmbr: "(8)",
            path: "sale-report-tax",
            icon: "",
            disb: pScr.tafseel,
            insh: inshs.Sales.saleVat,
          },
          {
            name: "sale-detail-rpt",
            nmbr: "(9)",
            path: "ReportSalTafsele",
            icon: "",
            disb: pScr.tafseel,
          },
          {
            name: "sale-analysis-rpt",
            nmbr: "(10)",
            path: "ReportSaleAnalysis",
            icon: "",
            disb: pScr.saleAnalysis,
          },
          {
            name: "sale-employee",
            nmbr: "(11)",
            path: "ReportEmpSales",
            icon: "",
            disb: pScr.empSale,
          },
          {
            name: "sale-profit",
            nmbr: "(12)",
            path: "CurrencySalesProfit",
            icon: "",
            disb: pScr.saleProfit,
          },
          // {name:'الحركة اليومية حسب المجموعة', nmbr:'(11)',  path:'', icon:'',disb:false},
          // {name:'هامش الربح تفصيلي', nmbr:'(12)',  path:'', icon:'',disb:false},
        ],
      },
      {
        tab: [
          {
            name: "sales_payment_report",
            nmbr: "(8)",
            path: "SadadInvoices",
            icon: "",
            disb: pScr.tafseel,
            insh: inshs.Sales.saleVat,
          },
          {
            name: "profit-margin",
            nmbr: "(13)",
            path: "ReportProfitMargin",
            icon: "",
            disb: pScr.profitMargin,
          },
          {
            name: "salesman_sales_report",
            nmbr: "(15)",
            path: "salesPersonComm",
            icon: "",
            disb: true,
          },
          {
            name: "preliminary-invoice",
            nmbr: "(3)",
            path: "Invoces",
            icon: "",
            disb: pScr.salView,
            insh: inshs.Sales.salAwleya,
          },
          {
            name: "resturant_invoice",
            nmbr: "14",
            path: "rest-invoice",
            icon: "",
            disb: pScr.sal,
            insh: inshs.Sales.sal,
          },

          {
            name: "dashboard",
            nmbr: "(16)",
            path: "chart",
            icon: "",
            disb: pScr.chart,
          },
          // {name:'تقرير مخصص حسب التاريخ', nmbr:'(18)',  path:'', icon:'',disb:false},
        ],
      },
      {
        tab: [
          {
            name:"debit-note",
            nmbr: "(3)",
            path: "Invoces",
            icon: "",
            disb: pScr.sal,
            insh: inshs.Sales.isharDept,
          },
          {
            name: "credit-note",
            nmbr: "(3)",
            path: "Invoces",
            icon: "",
            disb: pScr.sal,
            insh: inshs.Sales.isharCredit,
          },
          {
            name:"work-order",
            nmbr: "(3)",
            path: "Invoces",
            icon: "",
            disb: pScr.salView,
            insh: inshs.Sales.salWorkOrder,
          },
          // {name:'تقرير مخصص حسب التاريخ', nmbr:'(18)',  path:'', icon:'',disb:false},
        ],
      },
      {
        tab: [
          {
            name: "حركة الصندوق",
            nmbr: "(19)",
            path: "",
            icon: "",
            disb: false,
          },
          {
            name: "بيانات العقود",
            nmbr: "(20)",
            path: "",
            icon: "",
            disb: false,
          },
        ],
      },
      {
        tab: [
          {
            name: "اعدادات المبيعات",
            nmbr: "(21)",
            path: "",
            icon: "",
            disb: false,
          },
          {
            name: "اعدادات نقاط البيع",
            nmbr: "(22)",
            path: "",
            icon: "",
            disb: false,
          },
          {
            name: "نظام الورديات",
            nmbr: "(23)",
            path: "",
            icon: "",
            disb: false,
          },
          {
            name: "اعدادات اخرى",
            nmbr: "(24)",
            path: "",
            icon: "",
            disb: false,
          },
        ],
      },
    ],
    style: inshst.sal,
  },
  {
    title: "purchases-title",
    leftitle: "purch-system",
    of: of.parush,
    tabs: [
      { name: "صفـحـــــــــة ", nmbr: 1, icon: "", disb: false },
      { name: 'صفـحـــــــــة ', nmbr: 2, icon: '', disb: false },
    ],
    grid: [
      {
        tab: [
          {
            name: "purchase-invoice",
            nmbr: "(1)",
            path: "Invoces",
            icon: "",
            disb: pScr.purch,
            insh: inshs.Purches.purch,
          },
          {
            name: "return-purchase",
            nmbr: "(2)",
            path: "Invoces",
            icon: "",
            disb: pScr.purchRet,
            insh: inshs.Purches.purchRet,
          },
          {
            name: "purchase-order",
            nmbr: "(3)",
            path: "Invoces",
            icon: "",
            disb: pScr.purchRet,
            insh: inshs.Purches.purchOrder,
          },
          {
            name: "purch-employee",
            nmbr: "(4)",
            path: "ReportEmpPurches",
            icon: "",
            disb: pScr.activ,
          },
          {
            name: "activity-purchase-report",
            nmbr: "(5)",
            path: "Activityp",
            icon: "",
            disb: pScr.activ,
          },

          {
            name: "puchases-details-reprt",
            nmbr: "(6)",
            path: "PurchaseDetails",
            icon: "",
            disb: pScr.saleAnalysis,
          },

          // {name:'مشتريات مندوب خلال فتره', nmbr:'(4)',  path:'', icon:'',disb:false},
          // {name:'الإجمالي بحسب نوع الفاتورة', nmbr:'(5)',  path:'', icon:'',disb:false},
          // {name:'تقرير تفصيلي للمشتريات', nmbr:'(6)',  path:'', icon:'',disb:false},
        ],
      },
      {
        tab: [
          {
            name: "purchases-payment-report",
            nmbr: "(5)",
            path: "SadadInvoices",
            icon: "",
            disb: pScr.activ,
            insh: inshs.Sales.purchVat,
          },

          {
            name: "puchases-vat-report",
            nmbr: "(5)",
            path: "sale-report-tax",
            icon: "",
            disb: pScr.activ,
            insh: inshs.Sales.purchVat,
          },

          {
            name: "purch-analysis-rpt",
            nmbr: "(6)",
            path: "ReportPurchAnalysis",
            icon: "",
            disb: pScr.saleAnalysis,
          },

        ],
      },
    ],
    style: inshst.purch,
  },
  {
    title: "stores-title",
    leftitle: "safe-system",
    of: of.safe,
    tabs: [
      { name: "صفـحـــــــــة ", nmbr: 1, icon: "", disb: false },
      { name: "صفـحـــــــــة ", nmbr: 2, icon: "", disb: false },
      // {name:'صفـحـــــــــة ',nmbr:3, icon:'',disb:false},
    ],
    grid: [
      {
        tab: [
          {
            name: "store-first-term",
            nmbr: "(1)",
            path: "Invoces",
            // path: "first-term-invoice",
            icon: "",
            disb: pScr.safe,
            insh: inshs.Safes.safe,
          },



          {
            name: "str-inv-stat",
            nmbr: "(2)",
            path: "ReportSafesJard",
            icon: "",
            disb: pScr.safJrd,
          },
          {
            name: "str-inv-stat-unit",
            nmbr: "(3)",
            path: "SafeGrdUnits",
            icon: "",
            disb: pScr.safJrd,
          },
          {
            name: "str-adjustment",
            nmbr: "(4)",
            path: "reStore",
            icon: "",
            disb: pScr.safJrd,
          },
          // {name:'ارصدة المخزن حتى تاريخ', nmbr:'(4)',  path:'', icon:'',disb:false,},
          {
            name: "str-item-trans",
            nmbr: "(5)",
            path: "curr-details-rpt",
            icon: "",
            disb: pScr.safJrd,
          },
          {
            name: "totals_movement_item",
            nmbr: "(6)",
            path: "ItemsTotalMovement",
            icon: "",
            disb: pScr.safJrd,
          },

          // {name:'اجمالي الحركات لصنف', nmbr:'(6)',  path:'', icon:'',disb:false,},
        ],
      },
      {
        tab: [
          // {name:'تسوية المخزون', nmbr:'(9)',  path:'', icon:'',disb:false,},

          {
            name: "made_order",
            nmbr: "(1)",
            path: "Invoces",
            // path: "first-term-invoice",
            icon: "",
            disb: pScr.safe,
            insh: inshs.Safes.manufacturing,
          },
          {
            name: "str-transfer",
            nmbr: "(7)",
            path: "StoreTransfer",
            icon: "",
            disb: true,
          },
          {
            name: "str-receipt",
            nmbr: "(11)",
            path: "ReceiveST",
            icon: "",
            disb: true,
          },
          {
            name: "str-twreed",
            nmbr: "(7)",
            path: "store-supp",
            icon: "",
            disb: true,
          },
          {
            name: "str-srf",
            nmbr: "(8)",
            path: "store-exch",
            icon: "",
            disb: true,
          },
          {
            name: "str-turnover",
            nmbr: "(6)",
            path: "trun-items-avg",
            icon: "",
            disb: pScr.safJrd,
          },

          // {name:'معدل الدوران والركود للأصناف', nmbr:'(12)',  path:'', icon:'',disb:false,},
        ],
      },

      // {
      //     tab:
      //     [
      //         {name:'الأصناف التي ستنتهي صلاحيتها', nmbr:'(13)',  path:'', icon:'',disb:false,},
      //     ],
      // },
    ],
    style: inshst.safe,
  },
  {
    title: "customers-and-suppliers-title",
    leftitle: "customers-and-suppliers-title",
    of: of.customer,
    tabs: [
      { name: "صفـحـــــــــة ", nmbr: 1, icon: "", disb: false },
      { name: "صفـحـــــــــة ", nmbr: 2, icon: "", disb: false },
    ],
    grid: [
      {
        tab: [
          {
            name: "cust-add",
            nmbr: "(1)",
            path: "Customers",
            icon: "",
            disb: pScr.addCust,
            insh: inshs.Customers[0],
          },
          {
            name: "sup-add",
            nmbr: "(2)",
            path: "Customers",
            icon: "",
            disb: pScr.addCust,
            // {name:'إضـافة مـورد جـديد', nmbr:'(2)',  path:'Customers', icon:'',disb:pScr.addCust,
            insh: inshs.Customers[1],
          },
          {
            name: "basic-customer-data",
            nmbr: "(3)",
            path: "SimData",
            icon: "",
            disb: pScr.groupCust,
            insh: inshs.bascData.Acts,
          },
          {
            name: "cust-account",
            nmbr: "(4)",
            path: "HesabCustA",
            icon: "",
            disb: pScr.custAcc,
            insh: inshs.Customers[2],
          },
          {
            name: "sup-account",
            nmbr: "(5)",
            path: "HesabCustM",
            icon: "",
            disb: pScr.custAcc,
            insh: inshs.Customers[3],
          },
          {
            name: "cust-balance",
            nmbr: "(6)",
            path: "BalanceCustRPT",
            icon: "",
            disb: pScr?.custBalance,
            insh: inshs.Customers[4],
          },
        ],
      },
      {
        tab: [
          // {name:'ارصدة حسابات الموردين', nmbr:'(7)',  path:'BalanceCustRPT', icon:'',disb:true,
          // insh:inshs.Customers[5] },
          {
            name: "cust-last-pay",
            nmbr: "(8)",
            path: "pay-trans",
            icon: "",
            disb: pScr.custPayTrans,
          },
          {
            name: "debt-aging-report",
            nmbr: "(9)",
            path: "AgelPeriod",
            icon: "",
            disb: pScr.custPayTrans,
          },
        ],

      },
    ],
    style: inshst.custm,
  },
  {
    title: "accounts-title",
    leftitle: "account-system",
    of: of.account,
    tabs: [
      { name: "صفـحـــــــــة ", nmbr: 1, icon: "", disb: false },
      { name: "صفـحـــــــــة ", nmbr: 2, icon: "", disb: false },
      { name: "صفـحـــــــــة ", nmbr: 3, icon: "", disb: false },
      // {name:'صفـحـــــــــة ',nmbr:4, icon:'',disb:false},
    ],
    grid: [
      {
        tab: [
          {
            name: "accounts-tree",
            nmbr: "(1)",
            path: "accounts-index",
            icon: "",
            disb: pScr.accountTree,
          },
          {
            name: "account-report",
            nmbr: "(2)",
            path: "ReportAcc",
            icon: "",
            disb: pScr.acc,
          },
          {
            name: "ext-receipt",
            nmbr: "(3)",
            path: "ext-receipt",
            icon: "",
            disb: pScr.sandQKh,
            insh: inshs.Accounts.sQKharji,
          },
          {
            name: "ext-exchange",
            nmbr: "(4)",
            path: "ext-exchange",
            icon: "",
            disb: pScr.sandSKh,
            insh: inshs.Accounts.sSKharji,
          },
          {
            name: "int-receipt",
            nmbr: "(5)",
            path: "int-receipt",
            icon: "",
            disb: pScr.sandQD,
            insh: inshs.Accounts.internalSQ,
          },
          {
            name: "int-exchange",
            nmbr: "(6)",
            path: "int-exchange",
            icon: "",
            disb: pScr.sandSD,
            insh: inshs.Accounts.internalSS,
          },
          // {name:'سند صرف داخلي مفرد', nmbr:'(4)',  path:'', icon:'',disb:false,},
        ],
      },
      {
        tab: [
          // {name:'شجرة الحسابات', nmbr:'(1)',  path:'accounts-index', icon:'',disb:true,},

          // {name:'كشف حساب عام', nmbr:'(1)',  path:'ReportAcc', icon:'',disb:pScr.acc,},
          {
            name: "mult-receipt",
            nmbr: "(7)",
            path: "mult-receipt",
            icon: "",
            disb: pScr.multiQ,
          },
          {
            name: "mult-exchange",
            nmbr: "(8)",
            path: "mult-exchange",
            icon: "",
            disb: pScr.multiS,
          },
          {
            name: "opening-restrictions",
            nmbr: "(14)",
            path: "opening-rest",
            icon: "",
            disb: true,
          },

          // {name:'عرض السندات الداخليه', nmbr:'(9)',  path:'', icon:'',disb:false,},
          // {name:'عرض السندات الخارجيه', nmbr:'(10)',  path:'', icon:'',disb:false,},
          // {name:'كشف حساب عام', nmbr:'(9)',  path:'ReportAcc', icon:'',disb:true,},
          // {name:'كشف حساب 2', nmbr:'(11)',  path:'', icon:'',disb:false,},
          {
            name: "daily-rest",
            nmbr: "(11)",
            path: "restInsert",
            icon: "",
            disb: pScr.restInsert,
          },

          {
            name: "tax-dec",
            nmbr: "(12)",
            path: "reportTax",
            icon: "",
            disb: pScr.taxRPT,
          },
          {
            name: "vat-return-2",
            nmbr: "(12)",
            path: "VatReports",
            icon: "",
            disb: pScr.taxRPT,
          },

        ],
      },
      {
        tab: [
          // {name:'القيود الأفتتاحية', nmbr:'(14)',  path:'', icon:'',disb:false,},
          // {name:'ادخال القيود اليومية', nmbr:'(15)',  path:'', icon:'',disb:false,},
          // {name:'عرض القيود اليومية', nmbr:'(16)',  path:'', icon:'',disb:false,},
          // {name:'اليومية العامة', nmbr:'(17)',  path:'', icon:'',disb:false,},
          // {name:'كشف حساب متقدم', nmbr:'(18)',  path:'', icon:'',disb:false,},
          // {name:'تقارير نظام الحسابات', nmbr:'',  path:'MainRBalance', icon:'',disb:pScr.accountRPT,},
          {
            name: "acc-sys-rpt",
            nmbr: "",
            path: "MainRBalance",
            icon: "",
            disb: pScr.accountRPT,
          },
          {
            name: "cost-center-analysis",
            nmbr: "",
            path: "costRpt",
            icon: "",
            disb: pScr.accountRPT,
          },
          {
            name: "general-journal-report",
            nmbr: "",
            path: "DailyJenral",
            icon: "",
            disb: pScr.accountRPT,
          },

        ],
      },
      {
        tab: [
          {
            name: "ميزان المراجعة رئيسي",
            nmbr: "(18)",
            path: "",
            icon: "",
            disb: false,
          },
          {
            name: "ميزان المراجعة تحليلي",
            nmbr: "(19)",
            path: "",
            icon: "",
            disb: false,
          },
          {
            name: "ارباح وخسائر رئيسي",
            nmbr: "(20)",
            path: "",
            icon: "",
            disb: false,
          },
          {
            name: "ارباح وخسائر تحليلي",
            nmbr: "(21)",
            path: "",
            icon: "",
            disb: false,
          },
          {
            name: "ميزانية عمومية رئيسي",
            nmbr: "(22)",
            path: "",
            icon: "",
            disb: false,
          },
          {
            name: "ميزانية عمومية تحليلي",
            nmbr: "(23)",
            path: "",
            icon: "",
            disb: false,
          },
        ],
      },
    ],
    style: inshst.account,
  },
  {
    title: "input-basic-data",
    leftitle: "basic-information-title",
    of: of.basic,
    tabs: [
      { id: 1, name: "page ", nmbr: 1, icon: "", disb: false },
      { id: 2, name: "page ", nmbr: 2, icon: "", disb: false },
      { id: 3, name: "page ", nmbr: 3, icon: "", disb: false },
      { id: 4, name: "page ", nmbr: 4, icon: "", disb: false },
      { id: 5, name: "page ", nmbr: 5, icon: "", disb: false },
    ],
    grid: [
      {
        tab: [
          {
            name: "basic-found-data",
            nmbr: "(1)",
            path: "Foundation",
            icon: "",
            disb: pScr.found,
            insh: inshs.bascData.Foundation,
          },
          {
            name: "basic-unit-data",
            nmbr: "(2)",
            path: "SimData",
            icon: "",
            disb: pScr.unit,
            insh: inshs.bascData.Units,
          },
          {
            name: "basic-product-data",
            nmbr: "(3)",
            path: "item",
            icon: "",
            disb: pScr.item,
            insh: itmes,
          },
          {
            name: "basic-group-product",
            nmbr: "(4)",
            path: "groups",
            icon: "",
            disb: pScr.itemGroup,
            insh: inshs.bascData.groups,
          },
          // {name:'مجموعات الأصناف', nmbr:'(5)',  path:'SimData', icon:'',disb:pScr.itemGroup,
          // insh:inshs.bascData.groups},
          {
            name: "basic-group-tax",
            nmbr: "(5)",
            path: "SimData",
            icon: "",
            disb: pScr.taxGroup,
            insh: inshs.bascData.tax_groups,
          },
          {
            name: "basic-branch-data",
            nmbr: "(6)",
            path: "NormData",
            icon: "",
            disb: pScr.branch,
            insh: inshs.bascData.Branches,
          },
          // {name:'تعريف الوحدات', nmbr:'(3)',  path:'SimData', icon:'',disb:pScr.unit,
          //  insh:inshs.bascData.Units},
          // {name:'تعريف الأصناف', nmbr:'(4)', path:'item', icon:'',disb:pScr.item,
          //  insh:inshs.bascData.itmes},

          // {name:'المجموعات الضريبية', nmbr:'(6)',  path:'SimData', icon:'',disb:pScr.taxGroup,
          //  insh:inshs.bascData.tax_groups},
        ],
      },
      {
        tab: [
          {
            name: "basic-safe-data",
            nmbr: "(7)",
            path: "safes",
            icon: "",
            disb: pScr.safes,
            insh: inshs.bascData.Safes,
          },
          {
            name: "basic-stock-data",
            nmbr: "(8)",
            path: "stocks",
            icon: "",
            disb: pScr.stocks,
            insh: inshs.bascData.Stocks,
          },
          {
            name: "basic-bank-data",
            nmbr: "(7)",
            path: "banks",
            icon: "",
            disb: pScr.bank,
            insh: inshs.bascData.Banks,
          },
          {
            name: "basic-center-data",
            nmbr: "(8)",
            path: "costCenters",
            icon: "",
            disb: pScr.centr,
            insh: inshs.bascData.costcenter,
          },
          {
            name: "basic-omla-data",
            nmbr: "(9)",
            path: "Omlat",
            icon: "",
            disb: pScr.omla,
            insh: inshs.bascData.omlat,
          },
          {
            name: "basic-books-data",
            nmbr: "(10)",
            path: "SimData",
            icon: "",
            disb: pScr.accBook,
            insh: inshs.bascData.AccountBooks,
          },
        ],
      },
      {
        tab: [
          {
            name: "basic-customer-data",
            nmbr: "(11)",
            path: "SimData",
            icon: "",
            disb: pScr.custGroup,
            insh: inshs.bascData.Acts,
          },
          // {name:'تعريف المخرجين', nmbr:'(13)',  path:'', icon:'',disb:pScr.mokharg},
          {
            name: "basic-countery-data",
            nmbr: "(14)",
            path: "SimData",
            icon: "",
            disb: pScr.country,
            insh: inshs.bascData.Countries,
          },
          {
            name: "basic-cities-data",
            nmbr: "(15)",
            path: "SimData",
            icon: "",
            disb: pScr.city,
            insh: inshs.bascData.Cities,
          },
          {
            name: "basic-area-data",
            nmbr: "(16)",
            path: "SimData",
            icon: "",
            disb: pScr.area,
            insh: inshs.bascData.Areas,
          },
          {
            name: "basic-div-data",
            nmbr: "(17)",
            path: "SimData",
            icon: "",
            disb: pScr.mang,
            insh: inshs.bascData.Managements,
          },
          {
            name: "basic-depart-data",
            nmbr: "(18)",
            path: "SimData",
            icon: "",
            disb: pScr.dept,
            insh: inshs.bascData.Departments,
          },
        ],
      },
      {
        tab: [
          {
            name: "basic-jobs-data",
            nmbr: "(19)",
            path: "SimData",
            icon: "",
            disb: pScr.job,
            insh: inshs.bascData.jobs,
          },
          {
            name: "bsic-card-pay",
            nmbr: "(20)",
            path: "SimData",
            icon: "",
            disb: pScr.cardType,
            insh: inshs.bascData.CardTypes,
          },
          {
            name: "define-salesmen",
            nmbr: "(12)",
            path: "salesPerson",
            icon: "",
            disb: pScr.salesmen,
          },
          {
            name: "تعريف المضخات",
            nmbr: "(12)",
            path: "Pumps",
            icon: "",
            disb: pScr.salesmen,
          },
          {
            name: "تعريف المستويات",
            nmbr: "(12)",
            path: "levels",
            icon: "",
            disb: pScr.salesmen,
          },
          {
            name: "تسعيرات الاصناف",
            nmbr: "(12)",
            path: "PricesLevels",
            icon: "",
            disb: pScr.salesmen,
          },
        ],
      },
      {
        tab: [
          {
            name: "تعريف الجلسات",
            nmbr: "(12)",
            path: "TawlaGroups",
            icon: "",
            disb: pScr.salesmen,
          },
          {
            name: "تعريف الطاولات",
            nmbr: "(12)",
            path: "Tawla",
            icon: "",
            disb: pScr.salesmen,
          },
          {
            name: "تعريف كود الخصم",
            nmbr: "(12)",
            path: "DiscountCode",
            icon: "",
            disb: pScr.salesmen,
          },
        ],
      },
    ],
    style: inshst.bascData.all,
  },
  {
    title: "users-and-permissions-title",
    leftitle: "users-and-permissions-title",
    of: of.users,
    tabs: [
      // {name:'صفـحـــــــــة ',nmbr:1, icon:'',disb:false},
      // {name:'صفـحـــــــــة ',nmbr:2, icon:'',disb:false},
      // {name:'صفـحـــــــــة ',nmbr:3, icon:'',disb:false},
    ],
    grid: [
      {
        tab: [
          {
            name: "define-employee",
            nmbr: "(1)",
            path: "employees",
            icon: "",
            disb: pScr.found,
          },
          {
            name: "edit-users-data",
            nmbr: "(2)",
            path: "users-curd",
            icon: "",
            disb: pScr.found,
          },
          {
            name: "users-permissions",
            nmbr: "(3)",
            path: "user-perms",
            icon: "",
            disb: pScr.found,
          },
          {
            name: "change-password",
            nmbr: "(4)",
            path: "change-password",
            icon: "",
            disb: true,
          },
          {
            name: "employee-advances",
            nmbr: "(4)",
            path: "EmpAdvances",
            icon: "",
            disb: true,
          },
          {
            name: "employee-salary-delivery-voucher",
            nmbr: "(4)",
            path: "SalaryPay",
            icon: "",
            disb: true,
          },
          // // {name:'خصائص المستخدم', nmbr:'(5)',  path:'', icon:'',disb:false,},
          // {name:'النسخ الاحتياطي واستعادة البيانات', nmbr:'(6)',  path:'', icon:'',disb:false,},
        ],
      },
    ],
    style: inshst.user,
  },
  {
    title: "system-settings-title",
    leftitle: "system-settings-title",
    of: of.setting,
    tabs: [
      { name: "page ", nmbr: 1, icon: "", disb: false },
      { name: 'صفـحـــــــــة  ', nmbr: 2, icon: '', disb: false },
    ],
    grid: [
      {
        tab: [
          // {name:'إعدادت الطابعات', nmbr:'(1)',  path:'Invoces', icon:'',disb:false,},
          {
            name: "default-settings",
            nmbr: "(2)",
            path: "default_setting",
            icon: "",
            disb: true,
          },
          {
            name: "apply-system-updates",
            nmbr: "(1)",
            path: "Refresh",
            icon: "",
            disb: true,
          },
          {
            name: "import-export-data",
            nmbr: "(4)",
            path: "",
            icon: "",
            disb: false,
          },
          {
            name: "general-settings",
            nmbr: "(5)",
            path: "permissions",
            icon: "",
            disb: pScr.found,
          },
          {
            name: "electronic-scale-settings",
            nmbr: "(10)",
            path: "electronic-scale",
            icon: "",
            disb: true,
          },
          {
            name: "zatca-link-settings",
            nmbr: "(10)",
            path: "zatca-settings",
            icon: "",
            disb: true,
          },
          // {name:'إعدادات المشتريات', nmbr:'(6)',  path:'', icon:'',disb:false,},
        ],

      },
      {
        tab: [
          {
            name: "maintenance-contract",
            nmbr: "(2)",
            path: "AnnualScreen",
            // path: "AnnualClosing",
            icon: "",
            disb: true,
          },
        ],
      },
      {
        tab: [
          {
            name: "stock-settings",
            nmbr: "(7)",
            path: "",
            icon: "",
            disb: false,
          },
          {
            name: "basic-data-settings",
            nmbr: "(8)",
            path: "",
            icon: "",
            disb: false,
          },
          {
            name: "other-settings",
            nmbr: "(9)",
            path: "",
            icon: "",
            disb: false,
          },
          {
            name: "electronic-scale-settings",
            nmbr: "(10)",
            path: "",
            icon: "",
            disb: false,
          },
          {
            name: "email-report-settings",
            nmbr: "(11)",
            path: "",
            icon: "",
            disb: false,
          },
          {
            name: "year-closing",
            nmbr: "(12)",
            path: "",
            icon: "",
            disb: false,
          },
        ],
      },
    ],
    style: inshst.setting,
  },
];

const transToSal = inshs.Sales.sal;
const transToPurch = inshs.Purches.purch;

export { local, elIcon, itmes, autos, inshs, transToSal, transToPurch };
